import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter} from 'react-router-dom'  
import {showNotification } from '../../actions/notifications'
import {updateRepo } from '../../actions/repos'
import {finishImageUpload } from '../../actions/modals'
import { newRepo } from '../../actions/repos'
import EditRepoModal from '../../components/repo/EditRepoModal' 
import EditRepoImageModal from '../../components/repo/EditRepoImageModal'
import {uploadRepoImageToCloudinary} from '../../actions/cloudinary'

class EditRepoContainer extends Component {
  
	constructor(props){
		super(props)
		this.showEditImageModal=this.showEditImageModal.bind(this)
		this.uploadImage=this.uploadImage.bind(this)
		this.handleNameChange=this.handleNameChange.bind(this)
		this.handleDescriptionChange=this.handleDescriptionChange.bind(this)
		this.deleteImage=this.deleteImage.bind(this)
		this.createRepo=this.createRepo.bind(this)
		this.handleBackgroundClick=this.handleBackgroundClick.bind(this)
		this.repoHasEdits=this.repoHasEdits.bind(this)
		this.handleKeyDown=this.handleKeyDown.bind(this)
		this.updateRepoDescription=this.updateRepoDescription.bind(this)
		this.saveRepoUpdates=this.saveRepoUpdates.bind(this)
	
		let repoName='New Pack'
		let repoDescription=''
		let repoImage = ''

		if(props.repo){
			repoName=props.repo.name
			repoDescription=props.repo.description
			repoImage=props.repo.image
		}


		this.state={
			showImageSearchModal:false,
			repoName:repoName,
			repoDescription:repoDescription,
			repoImage:repoImage,
			uploadingToCloudinary:false,
			imageToUploadOnCreate:null,
			submitLoading:false
		}        

	}        





	UNSAFE_componentWillReceiveProps(nextProps) {
		if(this.props.uploadingImage !== nextProps.uploadingImage && nextProps.uploadingImage) {
			if(this.props.repo){
				this.uploadImage(nextProps.uploadingImage,nextProps.thumbnail)
			}else{
				this.setState({imageToUploadOnCreate:nextProps.uploadingImage,showImageSearchModal:false})
			}
		}
		
	}



	componentDidMount() {
		window.addEventListener('keydown', this.handleKeyDown)
  		
	}
	
	componentWillUnmount() {
		window.removeEventListener('keydown', this.handleKeyDown)

	}

 	repoHasEdits(){
		const {repoName,repoDescription,repoImage,uploadingToCloudinary} = this.state
		const {repo} = this.props
		if(uploadingToCloudinary){
			return true
		}
		else if(repo){
			const {name,description,image} = repo
			if(repoName !== name){
				return true
			}else if(repoDescription !== description){
				return true
			}else if (repoImage !== image){
				return true
			}
			else return false
		}else return true

	}




	deleteImage(){
		this.setState({repoImage:''})
	}


	createRepo(){
		this.setState({submitLoading:true})
		this.props.newRepo({name:this.state.repoName,description:this.state.repoDescription,image:''}).then((response) => {
			const {imageToUploadOnCreate} = this.state
			
			if(imageToUploadOnCreate){		
				this.props.uploadRepoImageToCloudinary(imageToUploadOnCreate,response.id).then((cloudinaryResponse) => {
					const version=cloudinaryResponse.version
					const imageString = `v${version}`
					this.props.finishImageUpload()
					
					const requestData = {...response,
						'image':imageString	
					}
					this.props.updateRepo(requestData).then(() => {
						this.props.hideModal()
						this.props.history.push(`/packs/${response.id}`) 
					})

				})
				 .catch((error) => {
				 })	
			}
			else{
				this.props.hideModal()
				this.props.history.push(`/packs/${response.id}`) 
			}
		})	

	}


	saveRepoUpdates(){
		this.setState({submitLoading:true})
		const nowDate = new Date()
		const requestData = {...this.props.repo,
			'name': this.state.repoName,
			'description':this.state.repoDescription,
			'image':this.state.repoImage,
			'clientModified': nowDate,
		}
		this.props.updateRepo(requestData).then(() => {
			this.props.hideModal()
			const notificationMessage=`${this.state.repoName}`
			this.props.showNotification(notificationMessage,'Updated','default')
		})
	}
		




	uploadImage(img,thumbnail) {
		this.setState({showImageSearchModal:false})
		this.setState({uploadingToCloudinary:true})
	
		this.props.uploadRepoImageToCloudinary(img,this.props.repo.id).then((response) => {
			const version=response.version
			this.setState({repoImage:`v${version}`})
			this.props.finishImageUpload()
			this.setState({uploadingToCloudinary:false})
			return `v${version}`

		})
		 .catch((error) => {
		 	this.setState({uploadingToCloudinary:false})
		 })
	}


	handleNameChange(e){
		this.setState({
			repoName:e.target.value,
		})
	}

	handleDescriptionChange(e){
		this.setState({
			repoDescription:e.target.value,
		})
	}

	updateRepoDescription(newDescription){ //for with paste
		this.setState({
			repoDescription:newDescription,
		})
	}


	showEditImageModal(){
		this.setState({showImageSearchModal:true})
	}


	handleKeyDown(e){
		if(e.keyCode === 27){//escape key
			if(this.state.showImageSearchModal){
				this.setState({showImageSearchModal:false})
			}	
			else {
				const {repo} = this.props
				if(!repo){
					this.props.hideModal()
				}else{
					const repoHasEdits= this.repoHasEdits()
					if(!repoHasEdits){
						this.props.hideModal()
					}
				}
			}
		}
		if(e.keyCode === 13){//escape key
			if(!this.state.showImageSearchModal){
				if(this.state.repoName){
					const {repo} = this.props
					if(!repo){
						this.createRepo()
			
					}
					else{
						this.saveRepoUpdates()
					}
				}
			}
		}
		}			

	handleBackgroundClick(){
		if(this.state.showImageSearchModal){
			this.setState({showImageSearchModal:false})
		}	
		else {
			const {repo} = this.props
			if(!repo){
				this.props.hideModal()
			}else{
				const repoHasEdits= this.repoHasEdits()
				if(!repoHasEdits){
					this.props.hideModal()
				}
			}
		}
	}



	render() {
		const {repo}=this.props
		const {showImageSearchModal}=this.state
		let submitButtonDisabled = false
		
		if(this.state.repoName === '' || this.state.uploadingToCloudinary){
			submitButtonDisabled = true
		}

		return(

			<React.Fragment>

				{!showImageSearchModal && 
					<div className='repoDetailsModalContainer'>
						<EditRepoModal
							repo={repo}
							newRepo={this.props.newRepo}
							hideModal={this.props.hideModal}
							showEditImageModal={this.showEditImageModal}
							repoName={this.state.repoName}
							repoDescription={this.state.repoDescription}
							repoImage={this.state.repoImage}
							handleNameChange={this.handleNameChange}
							handleDescriptionChange={this.handleDescriptionChange}
							deleteImage={this.deleteImage}
							uploadingToCloudinary={this.state.uploadingToCloudinary}
							imageToUploadOnCreate={this.state.imageToUploadOnCreate}
							deletePendingImage={()=>{this.setState({imageToUploadOnCreate:null})}}
							createRepo={this.createRepo}
							showNotification={this.props.showNotification}
							submitButtonDisabled={submitButtonDisabled}
							updateRepoDescription={this.updateRepoDescription}
							updateRepo={this.saveRepoUpdates}
							submitLoading={this.state.submitLoading}

						/>
						<div className='repoDetailsModalBackground' onClick={this.handleBackgroundClick} />
					</div>
				}
				
				{showImageSearchModal && 
					<div className='repoDetailsModalContainer'>
						<EditRepoImageModal
							closeImageSearch={()=>{this.setState({showImageSearchModal:false})}}
						/>
						<div className='repoDetailsModalBackground' onClick={this.handleBackgroundClick} />
					</div>
				}


 


			

			</React.Fragment>

		)		
	}
}


export default withRouter(connect(
	(state) => ({uploadingImage:state.modals.image}),
	{newRepo, 
		showNotification,
		updateRepo,
		uploadRepoImageToCloudinary,
		finishImageUpload,
		}
)(EditRepoContainer))





// WEBPACK FOOTER //
// ./src/containers/modals/EditRepoContainer.js